import { fromJS } from 'immutable';
import { useMemo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';

//@ts-expect-error Untyped import
import FilterOperatorDisplay from 'customer-data-filters/components/operator/FilterOperatorDisplay';
import { fromObjectSegFilterStrict } from 'customer-data-filters/converters/objectSeg/fromObjectSegFilter';
import DSFieldRecord from 'customer-data-filters/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { toPropertyBasicType } from '../../../../../dataset/type-utils';
//@ts-expect-error Untyped import
import DeletedPropertyFilterLabel from '../property-filter/DeletedPropertyFilterLabel';
//@ts-expect-error Untyped import
import PropertyFilterLabel from '../property-filter/PropertyFilterLabel';
import { Field } from '../../../../schema/column-records';
import { getIsUngated, useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
//@ts-expect-error Untyped import
import { useField, useSourceMeta } from '../SourceMeta';
import { buildSpecialOptionsByReferenceType, SNOWFLAKE_FILTER_FAMILY
//@ts-expect-error Untyped import
} from '../../xo-filter-utils';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styled from 'styled-components';
import { Expression } from '../../../../../dataset/expression-records';
import { useFilterTypeContext } from '../FilterTypeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpanContainer = styled.div.withConfig({
  displayName: "FieldFilterLabel__StyledSpanContainer",
  componentId: "sc-17oo528-0"
})(["display:block;font-weight:600;margin-bottom:-4px;"]);
const getMappedProps = (filter, field, datasetField, userId, userGates) => {
  const {
    filter: fieldFilter
  } = filter;
  const getReferencedObjectType = () => null;
  const getFamilyValueResolver = () => null;
  const label = datasetField.label;
  const operator = fieldFilter && fieldFilter.get('operation') ? fromObjectSegFilterStrict(fieldFilter.toJS(), () => DSFieldRecord(fromJS({
    label,
    name: field.name,
    type: field.type
  })), SNOWFLAKE_FILTER_FAMILY, gate => getIsUngated(gate, userGates), true) : undefined;
  const datasetFieldPropertyType = 'propertyType' in datasetField.type && datasetField.type.propertyType;
  return {
    currencyCode: 'USD',
    isReadOnly: true,
    isXoEnabled: true,
    operator,
    getSpecialOptionsForReferenceType: buildSpecialOptionsByReferenceType(datasetFieldPropertyType, userId),
    getLabelString: () => datasetField.label,
    getReferencedObjectType,
    getFamilyValueResolver
  };
};
const FieldFilterLabel = ({
  filter
}) => {
  const {
    field
  } = filter;
  const datasetField = useField(field.name);
  const {
    userId,
    userGates
  } = useFilterRelevantUserInfo();
  const sourceMeta = useSourceMeta();
  const {
    context
  } = useFilterTypeContext();
  const filterOperatorDisplayProps = useMemo(() => {
    if (!datasetField.derived) {
      return undefined;
    }
    return getMappedProps(filter, field, datasetField, userId, userGates);
  }, [datasetField, filter, field, userId, userGates]);
  if (!datasetField.derived) {
    const expression = Expression(datasetField.expression);
    const propertyFilter = filter.set('field', Field({
      name: expression.name,
      table: expression.table,
      type: datasetField.type.propertyType
    }));
    const propertyExists = sourceMeta && !!sourceMeta.datasetMeta.properties.getIn([expression.table, expression.name]);
    if (!propertyExists) {
      return /*#__PURE__*/_jsx(DeletedPropertyFilterLabel, {
        filter: propertyFilter
      });
    }
    return /*#__PURE__*/_jsx(PropertyFilterLabel, {
      filter: propertyFilter
    });
  }
  const sameFieldType = toPropertyBasicType(datasetField.type) === field.type;
  const isValidContext = context === 'AGGREGATE' ? datasetField.context === 'AGGREGATE' || datasetField.input.includes('FIXED') : context === 'GROUPED_SUMMARY' ? datasetField.context === 'AGGREGATE' : datasetField.context === 'ROW_LEVEL' || datasetField.context === 'CONSTANT';
  const isValid = datasetField.valid && sameFieldType && isValidContext;
  let invalidFilterMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-snowflake.filter-editor.dataset-field.invalid"
  });
  if (!sameFieldType) {
    invalidFilterMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-snowflake.filter-editor.dataset-field.field-type-changed"
    });
  } else if (!isValidContext) {
    invalidFilterMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-snowflake.filter-editor.dataset-field.context-changed"
    });
  }
  const content = filterOperatorDisplayProps && filterOperatorDisplayProps.operator ? /*#__PURE__*/_jsx(FilterOperatorDisplay, Object.assign({}, filterOperatorDisplayProps, {
    getIsUngated: gate => getIsUngated(gate, userGates)
  })) : /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx("strong", {
      children: filterOperatorDisplayProps && filterOperatorDisplayProps.getLabelString()
    })
  });
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "dataset-field-filter-label",
    children: [/*#__PURE__*/_jsx(StyledSpanContainer, {
      children: /*#__PURE__*/_jsx(Text, {
        children: I18n.text('reporting-snowflake.filter-editor.dataset-field.label')
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: invalidFilterMessage,
      disabled: isValid,
      children: /*#__PURE__*/_jsx(Text, {
        color: !isValid ? 'text-alert-default' : 'text-core-default',
        children: content
      })
    })]
  });
};
export default FieldFilterLabel;